var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransport1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52812 2.4276C1.20706 3.44248 0.936557 4.47414 0.708984 5.51549H7.72222V0H4.8219C3.30465 0 1.9805 0.976562 1.52812 2.4276Z",
    fill: "#152424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.115841 9.08156C0.0662042 9.48983 0.0275795 9.90362 0 10.345V12.3753C0 12.9062 0.212823 13.3863 0.55425 13.7407C0.582705 11.9396 2.05422 10.4828 3.86193 10.4828C5.68737 10.4828 7.17228 11.9677 7.17228 13.7932C7.17228 13.9816 7.15282 14.1651 7.12244 14.345H7.72239V6.61914H0.49239C0.34109 7.43602 0.208648 8.2564 0.115841 9.08156Z",
    fill: "#152424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9309 0H8.82568V14.3448H17.7047C17.6744 14.1649 17.6549 13.9814 17.6549 13.793C17.6549 11.9675 19.1398 10.4826 20.9652 10.4826C22.7907 10.4826 24.2756 11.9675 24.2756 13.793C24.2756 13.9814 24.2561 14.1649 24.2257 14.3448H25.9309C26.2343 14.3448 26.4826 14.0966 26.4826 13.7931V0.551724C26.4826 0.248249 26.2343 0 25.9309 0Z",
    fill: "#152424"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86217 15.9997C5.08101 15.9997 6.06907 15.0117 6.06907 13.7928C6.06907 12.574 5.08101 11.5859 3.86217 11.5859C2.64333 11.5859 1.65527 12.574 1.65527 13.7928C1.65527 15.0117 2.64333 15.9997 3.86217 15.9997Z",
    fill: "#152424"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9652 15.9997C22.184 15.9997 23.1721 15.0117 23.1721 13.7928C23.1721 12.574 22.184 11.5859 20.9652 11.5859C19.7464 11.5859 18.7583 12.574 18.7583 13.7928C18.7583 15.0117 19.7464 15.9997 20.9652 15.9997Z",
    fill: "#152424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport1);
export default __webpack_public_path__ + "static/media/transport (1).c2193c6813d3364649c76d345f868438.svg";
export { ForwardRef as ReactComponent };